import React from 'react'
import {connect} from 'react-redux'
import styles from '../common.module.scss'
import CollapsibleGroup from '../CollapsibleGroup'
import Accomplishment from './Accomplishment'
import {ConfirmModal} from '../ConfirmModal'
import toast from 'react-hot-toast'
import axios from 'axios'

class _AccomplishmentsTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.items,
      selectedItemIndex: null,
      showConfirmationWindow: false,
    }
  }

  onSaveAndApprove = (index) => {
    this.setState({selectedItemIndex: index, showConfirmationWindow: true})
  }

  onUpdate = (index, data) => {
    this.setState({
      items: this.state.items
        .slice(0, index)
        .concat([{...this.state.items[index], accomplishment: data}])
        .concat(this.state.items.slice(index + 1)),
    })
  }

  onSave = (username, accomplishments) => {
    this.props.updateAccomplishment(username, accomplishments)
  }

  handleConfirmationWindowResult = (result) => {
    if (result) {
      this.saveAccomplishment(this.state.selectedItemIndex, true)
    } else {
      this.setState({selectedItemIndex: null, showConfirmationWindow: false})
    }
  }

  saveAccomplishment = (index, approve = undefined) => {
    const self = this
    self.setState({showConfirmationWindow: false})
    axios
      .post('/proofreader/accomplishment', {
        username: this.state.items[index].person.slug,
        accomplishment: this.state.items[index].accomplishment,
        approve,
      })
      .then(function (response) {
        toast.success(`The accomplishment was ${approve ? 'approved' : 'saved'} successfully.`)
        self.onSave(self.state.items[index].person.slug, response.data.accomplishments)
        if (approve) {
          self.setState({
            selectedItemIndex: null,
            items: self.state.items
              .slice(0, self.state.selectedItemIndex)
              .concat(self.state.items.slice(self.state.selectedItemIndex + 1)),
          })
        }
      })
      .catch(function (error) {
        toast.error('Server error!')
        console.log(error) // eslint-disable-line no-console
        self.setState({selectedItemIndex: null})
      })
  }

  render() {
    return (
      <>
        <div className={styles.headingWithButtonContainer}>
          <h3 className={styles.heading}>Accomplishments</h3>
        </div>
        <CollapsibleGroup
          data={this.state.items}
          getElementFromData={(a, index) => (
            <Accomplishment accomplishment={a.accomplishment} onUpdate={(data) => this.onUpdate(index, data)} />
          )}
          getTitleFromData={(a) => `${a.person.name} - ${a.accomplishment.title}`}
          openIndices={null}
          buttons={[
            {title: 'Save', onClick: (index) => this.saveAccomplishment(index)},
            {title: 'Save & Approve', onClick: (index) => this.onSaveAndApprove(index)},
          ]}
        />
        {this.state.items.length === 0 && <div>All accomplishment records are approved!</div>}
        {this.state.showConfirmationWindow && (
          <ConfirmModal
            handleResult={this.handleConfirmationWindowResult}
            confirmButtonText="Approve"
            title="Approve Accomplishment"
            message={`Are you sure you want to approve the accomplishment of "${
              this.state.items[this.state.selectedItemIndex].person.name
            }"?`}
          />
        )}
        <div className={styles.gap320} />
      </>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateAccomplishment: (jiraID, accomplishments) =>
      dispatch({
        type: 'Update Person Accomplishment',
        path: ['accessiblePeople', jiraID],
        reducer: (state) => ({
          ...state,
          accomplishments,
        }),
      }),
  }
}

export default connect((state) => {
  const items = []
  for (const person of Object.values(state.accessiblePeople)) {
    const acc = person.accomplishments
      .filter((a) => !a.proofread && a.description !== '')
      .map((a) => ({person, accomplishment: a}))
    items.push(...acc)
  }
  return {
    user: state.user,
    items,
  }
}, mapDispatchToProps)(_AccomplishmentsTab)
